import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL, STAFF_MY_BRANCHES_API } from "utilities";

const authHeader = () => ({ Authorization: localStorage.getItem("token") });

export const myBranchesKeys = {
  all: ["my-branches"],
};

const fetchMyBranches = () =>
  axios
    .get(`${API_BASE_URL}${STAFF_MY_BRANCHES_API}`, { headers: authHeader() })
    .then((r) => r.data);

/** Every branch the logged-in user has an active Staff row at. A single login
 * can now be Staff at more than one branch -- used to drive the branch
 * switcher, which only renders once this returns more than one row. */
export function useMyBranches(options = {}) {
  return useQuery({
    queryKey: myBranchesKeys.all,
    queryFn: fetchMyBranches,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
